import { Procedure } from "src/app/components/procedure/models/procedure.model";

export class ProcedureMaster {
  id!: number;
  procedure?: Procedure;
}
